"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AzureRepo = exports.API_NAME = void 0;

var _trim2 = _interopRequireDefault(require("lodash/trim"));

var _result2 = _interopRequireDefault(require("lodash/result"));

var _partial2 = _interopRequireDefault(require("lodash/partial"));

var _flow2 = _interopRequireDefault(require("lodash/flow"));

var _first2 = _interopRequireDefault(require("lodash/first"));

var _jsBase = require("js-base64");

var _netlifyCmsLibUtil = require("netlify-cms-lib-util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const API_NAME = 'Azure DevOps';
exports.API_NAME = API_NAME;

class AzureRepo {
  constructor(location) {
    _defineProperty(this, "org", void 0);

    _defineProperty(this, "project", void 0);

    _defineProperty(this, "name", void 0);

    if (!location || !/^[^/]+\/[^/]+(|\/[^/]+)$/gi.test(location)) {
      throw new Error("An Azure repository must be specified in the format 'organisation/project', or 'organisation/project/repo'.");
    }

    const components = (0, _trim2.default)(location, '/').split('/', 3);
    this.org = components[0];
    this.project = components[1];
    this.name = components[2] || components[1];
  }

}

exports.AzureRepo = AzureRepo;
var AzureCommitChangeType;

(function (AzureCommitChangeType) {
  AzureCommitChangeType["ADD"] = "add";
  AzureCommitChangeType["DELETE"] = "delete";
  AzureCommitChangeType["RENAME"] = "rename";
  AzureCommitChangeType["EDIT"] = "edit";
})(AzureCommitChangeType || (AzureCommitChangeType = {}));

var AzureCommitContentType;

(function (AzureCommitContentType) {
  AzureCommitContentType["RAW"] = "rawtext";
  AzureCommitContentType["BASE64"] = "base64encoded";
})(AzureCommitContentType || (AzureCommitContentType = {}));

var AzurePullRequestStatus;

(function (AzurePullRequestStatus) {
  AzurePullRequestStatus["ACTIVE"] = "active";
  AzurePullRequestStatus["COMPLETED"] = "completed";
  AzurePullRequestStatus["ABANDONED"] = "abandoned";
})(AzurePullRequestStatus || (AzurePullRequestStatus = {}));

var AzureAsyncPullRequestStatus; // https://docs.microsoft.com/en-us/rest/api/azure/devops/git/diffs/get?view=azure-devops-rest-5.1#gitcommitdiffs

(function (AzureAsyncPullRequestStatus) {
  AzureAsyncPullRequestStatus["CONFLICTS"] = "conflicts";
  AzureAsyncPullRequestStatus["FAILURE"] = "failure";
  AzureAsyncPullRequestStatus["QUEUED"] = "queued";
  AzureAsyncPullRequestStatus["REJECTED"] = "rejectedByPolicy";
  AzureAsyncPullRequestStatus["SUCCEEDED"] = "succeeded";
})(AzureAsyncPullRequestStatus || (AzureAsyncPullRequestStatus = {}));

class AzureRef {
  constructor(name, objectId) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "objectId", void 0);

    this.name = name;
    this.objectId = objectId;
  }

}

class AzureChangeContent {
  constructor(content, type) {
    _defineProperty(this, "content", void 0);

    _defineProperty(this, "contentType", void 0);

    this.content = content;
    this.contentType = type;
  }

}

class AzureCommitChangeItem {
  constructor(path) {
    _defineProperty(this, "path", void 0);

    this.path = path;
  }

}

class AzureCommitChange {
  constructor(changeType, path) {
    _defineProperty(this, "changeType", void 0);

    _defineProperty(this, "item", void 0);

    this.changeType = changeType;
    this.item = new AzureCommitChangeItem(path);
  }

}

class AzureCommitAddChange extends AzureCommitChange {
  constructor(path, content, type) {
    super(AzureCommitChangeType.ADD, path);

    _defineProperty(this, "newContent", void 0);

    this.newContent = new AzureChangeContent(content, type);
  }

}

class AzureCommitEditChange extends AzureCommitChange {
  constructor(path, content, type) {
    super(AzureCommitChangeType.EDIT, path);

    _defineProperty(this, "newContent", void 0);

    this.newContent = new AzureChangeContent(content, type);
  }

}

class AzureCommitRenameChange extends AzureCommitChange {
  constructor(source, destination) {
    super(AzureCommitChangeType.RENAME, destination);

    _defineProperty(this, "sourceServerItem", void 0);

    this.sourceServerItem = source;
  }

}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
/**
 * Change list provides an easy way to create a range of different changes on a single
 * commit. Rename serves as move.
 */


class AzureChangeList extends Array {
  constructor() {
    super();
  }

  addBase64(path, base64data) {
    this.push(new AzureCommitAddChange(path, base64data, AzureCommitContentType.BASE64));
  }

  addRawText(path, text) {
    this.push(new AzureCommitAddChange(path, text, AzureCommitContentType.RAW));
  }

  delete(path) {
    this.push(new AzureCommitChange(AzureCommitChangeType.DELETE, path));
  }

  editBase64(path, base64data) {
    this.push(new AzureCommitEditChange(path, base64data, AzureCommitContentType.BASE64));
  }

  rename(source, destination) {
    this.push(new AzureCommitRenameChange(source, destination));
  }

}

class AzureCommit {
  constructor(comment = 'Default commit comment') {
    _defineProperty(this, "comment", void 0);

    _defineProperty(this, "changes", void 0);

    this.comment = comment;
    this.changes = new AzureChangeList();
  }

}

class AzurePush {
  constructor(ref) {
    _defineProperty(this, "refUpdates", void 0);

    _defineProperty(this, "commits", void 0);

    this.refUpdates = [{
      name: ref.name,
      oldObjectId: ref.objectId
    }];
    this.commits = [];
  }

}

class AzurePRLabel {
  constructor(id, name) {
    _defineProperty(this, "id", void 0);

    _defineProperty(this, "name", void 0);

    this.id = id;
    this.name = name;
  }

}

class API {
  constructor(config, token) {
    var _this$repo, _this$repo2, _this$repo3;

    _defineProperty(this, "apiRoot", void 0);

    _defineProperty(this, "apiVersion", void 0);

    _defineProperty(this, "token", void 0);

    _defineProperty(this, "branch", void 0);

    _defineProperty(this, "squashMerges", void 0);

    _defineProperty(this, "repo", void 0);

    _defineProperty(this, "endpointUrl", void 0);

    _defineProperty(this, "initialWorkflowStatus", void 0);

    _defineProperty(this, "commitAuthor", void 0);

    _defineProperty(this, "withAuthorizationHeaders", req => _netlifyCmsLibUtil.unsentRequest.withHeaders(this.token ? {
      Authorization: "Bearer ".concat(this.token)
    } : {}, req));

    _defineProperty(this, "withAzureFeatures", req => {
      req = _netlifyCmsLibUtil.unsentRequest.withHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        Origin: '*'
      }, req);
      req = _netlifyCmsLibUtil.unsentRequest.withDefaultParams({
        'api-version': this.apiVersion
      }, req);
      return req;
    });

    _defineProperty(this, "buildRequest", req => (0, _flow2.default)([_netlifyCmsLibUtil.unsentRequest.withRoot(this.apiRoot), this.withAuthorizationHeaders, this.withAzureFeatures, _netlifyCmsLibUtil.unsentRequest.withTimestamp])(req));

    _defineProperty(this, "request", async req => (0, _flow2.default)([this.buildRequest, _netlifyCmsLibUtil.unsentRequest.performRequest, p => p.catch(err => Promise.reject(new _netlifyCmsLibUtil.APIError(err.message, null, API_NAME)))])(req));

    _defineProperty(this, "responseToJSON", (0, _netlifyCmsLibUtil.responseParser)({
      format: 'json',
      apiName: API_NAME
    }));

    _defineProperty(this, "responseToBlob", (0, _netlifyCmsLibUtil.responseParser)({
      format: 'blob',
      apiName: API_NAME
    }));

    _defineProperty(this, "responseToText", (0, _netlifyCmsLibUtil.responseParser)({
      format: 'text',
      apiName: API_NAME
    }));

    _defineProperty(this, "requestJSON", req => this.request(req).then(this.responseToJSON));

    _defineProperty(this, "requestText", req => this.request(req).then(this.responseToText));

    _defineProperty(this, "toBase64", str => Promise.resolve(_jsBase.Base64.encode(str)));

    _defineProperty(this, "fromBase64", str => _jsBase.Base64.decode(str));

    _defineProperty(this, "branchToRef", branch => "refs/heads/".concat(branch));

    _defineProperty(this, "refToBranch", ref => ref.substr(11));

    _defineProperty(this, "user", () => {
      return this.requestJSON({
        url: 'https://app.vssps.visualstudio.com/_apis/profile/profiles/me'
      });
    });

    _defineProperty(this, "readFile", async (path, sha, {
      parseText = true,
      branch = this.branch
    } = {}) => {
      const fetchContent = async () => {
        return await this.request({
          url: "".concat(this.endpointUrl, "/items/"),
          params: {
            version: branch,
            path
          },
          cache: 'no-store'
        }).then(parseText ? this.responseToText : this.responseToBlob);
      };

      return await (0, _netlifyCmsLibUtil.readFile)(sha, fetchContent, _netlifyCmsLibUtil.localForage, parseText);
    });

    _defineProperty(this, "listFiles", async (path, recursive = false) => {
      return await this.requestJSON({
        url: "".concat(this.endpointUrl, "/items/"),
        params: {
          version: this.branch,
          path,
          recursionLevel: recursive ? 'full' : 'none'
        } // Azure

      }).then(response => {
        // Get the real URL of the tree data and hit it.
        return response._links.tree.href;
      }).then(url => {
        return this.requestJSON(url);
      }).then(response => {
        const files = response.treeEntries || [];

        if (!Array.isArray(files)) {
          throw new Error("Cannot list files, path ".concat(path, " is not a directory but a ").concat(typeof files));
        }

        files.forEach(f => {
          f.relativePath = "".concat(path, "/").concat(f.relativePath);
        });
        return files;
      }).then(files => files.filter(file => file.gitObjectType === 'blob')); // Azure
    });

    this.repo = config.repo;
    this.apiRoot = (0, _trim2.default)(config.apiRoot, '/') || 'https://dev.azure.com';
    this.endpointUrl = "".concat(this.apiRoot, "/").concat((_this$repo = this.repo) === null || _this$repo === void 0 ? void 0 : _this$repo.org, "/").concat((_this$repo2 = this.repo) === null || _this$repo2 === void 0 ? void 0 : _this$repo2.project, "/_apis/git/repositories/").concat((_this$repo3 = this.repo) === null || _this$repo3 === void 0 ? void 0 : _this$repo3.name);
    this.token = token || undefined;
    this.branch = config.branch || 'master';
    this.squashMerges = config.squashMerges || true;
    this.initialWorkflowStatus = config.initialWorkflowStatus;
    this.apiVersion = '5.1'; // Azure API version is recommended and sometimes even required
  }

  async retrieveMetadata(contentKey) {
    var _mergeRequest$labels;

    const {
      collection,
      slug
    } = (0, _netlifyCmsLibUtil.parseContentKey)(contentKey);
    const branch = this.branchFromContentKey(contentKey);
    const mergeRequest = await this.getBranchPullRequest(branch);
    const diff = await this.getDifferences(mergeRequest.sourceRefName);
    const path1 = diff.find(d => d.item.path.includes(slug));
    const path = path1 === null || path1 === void 0 ? void 0 : path1.item.path;
    const mediaFiles = diff.filter(d => !d.item.isFolder).map(d => {
      const path = d.item.path;
      const id = d.item.objectId;
      return {
        path,
        id
      };
    });
    const prLabel = (_mergeRequest$labels = mergeRequest.labels) === null || _mergeRequest$labels === void 0 ? void 0 : _mergeRequest$labels.find(l => (0, _netlifyCmsLibUtil.isCMSLabel)(l.name));
    const labelText = prLabel ? prLabel.name : (0, _netlifyCmsLibUtil.statusToLabel)('draft');
    const status = (0, _netlifyCmsLibUtil.labelToStatus)(labelText);
    return {
      branch,
      collection,
      slug,
      path,
      status,
      mediaFiles
    };
  }
  /**
   * Reads a single file from an Azure DevOps Git repository, using the 'items' endpoint,
   * with the path to the desired file. Parses the response whether it's a string or blob,
   * and then passes the retrieval function to the central readFile cache.
   * @param path The repo-relative path of the file to read.
   * @param sha  Null. Not used by the Azure implementation.
   * @param opts Override options.
   */


  /**
   * Gets an AzureRef representing the HEAD commit of the specified branch.
   * @param branch The name of the branch to get a commit ref for.
   */
  async getRef(branch = this.branch) {
    return this.requestJSON({
      url: "".concat(this.endpointUrl, "/refs"),
      params: {
        $top: '1',
        // There's only one, so keep the payload small
        filter: 'heads/' + branch
      }
    }).then(refs => {
      return (0, _first2.default)(refs.value.filter(b => b.name == this.branchToRef(branch)));
    });
  }

  async deleteRef(ref) {
    const deleteBranchPayload = [{
      name: ref.name,
      oldObjectId: ref.objectId,
      newObjectId: '0000000000000000000000000000000000000000'
    }];
    await this.requestJSON({
      method: 'POST',
      url: "".concat(this.endpointUrl, "/refs"),
      body: JSON.stringify(deleteBranchPayload)
    });
  }

  uploadAndCommit(items, comment = 'Creating new files', branch = this.branch, newBranch = false) {
    return this.getRef(branch).then(async ref => {
      if (ref == null) {
        ref = await this.getRef(this.branch);
      }

      if (newBranch) {
        ref = new AzureRef(this.branchToRef(branch), ref.objectId);
      }

      console.log(JSON.stringify(ref));
      const commit = new AzureCommit(comment);
      items.forEach(i => {
        switch (i.action) {
          case AzureCommitChangeType.ADD:
            commit.changes.addBase64(i.path, i.base64Content);
            break;

          case AzureCommitChangeType.EDIT:
            commit.changes.editBase64(i.path, i.base64Content);
            break;

          case AzureCommitChangeType.DELETE:
            commit.changes.delete(i.path);
            break;

          case AzureCommitChangeType.RENAME:
            commit.changes.rename(i.path, i.path);
            break;
        }
      }); // Only bother with a request if we're going to make changes.

      if (commit.changes.length > 0) {
        const push = new AzurePush(ref);
        push.commits.push(commit);
        return this.requestJSON({
          url: "".concat(this.endpointUrl, "/pushes"),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8'
          },
          body: JSON.stringify(push)
        });
      }
    });
  }

  async readUnpublishedBranchFile(contentKey) {
    const {
      branch,
      collection,
      slug,
      path,
      status,
      mediaFiles
    } = await this.retrieveMetadata(contentKey);
    const [fileData, isModification] = await Promise.all([this.readFile(path, null, {
      branch
    }), this.isFileExists(path, this.branch)]);
    return {
      slug,
      metaData: {
        branch,
        collection,
        objects: {
          entry: {
            path,
            mediaFiles
          }
        },
        status
      },
      fileData,
      isModification
    };
  }

  isUnpublishedEntryModification(path, branch) {
    return this.readFile(path, null, {
      branch
    }).then(() => true).catch(err => {
      if (err.message && err.message === 'Not Found') {
        return false;
      }

      throw err;
    });
  }
  /**
   * Retrieve statuses for a given SHA. Unrelated to the editorial workflow
   * concept of entry "status". Useful for things like deploy preview links.
   */
  // async getStatuses(collection: string, slug: string) {


  async getStatuses(collection, slug) {
    const contentKey = (0, _netlifyCmsLibUtil.generateContentKey)(collection, slug);
    const branch = this.branchFromContentKey(contentKey); // eslint-disable-next-line @typescript-eslint/no-unused-vars

    await this.getBranchPullRequest(branch);
    const statuses = []; // eslint-disable-next-line @typescript-eslint/camelcase

    return statuses.map(({
      name,
      status,
      target_url
    }) => ({
      context: name,
      state: status ? _netlifyCmsLibUtil.PreviewState.Success : _netlifyCmsLibUtil.PreviewState.Other,
      // eslint-disable-next-line @typescript-eslint/camelcase
      target_url
    }));
  }

  async getCommitItems(files, branch) {
    const items = await Promise.all(files.map(async file => {
      const [base64Content, fileExists] = await Promise.all([(0, _result2.default)(file, 'toBase64', (0, _partial2.default)(this.toBase64, file.raw)), this.isFileExists(file.path, branch)]);
      return {
        action: fileExists ? AzureCommitChangeType.EDIT : AzureCommitChangeType.ADD,
        base64Content,
        path: '/' + (0, _trim2.default)(file.path, '/')
      };
    }));
    return items;
  }
  /**
   * Store a resource in the target repository.
   * @param entry
   * @param mediaFiles
   * @param options
   */


  async persistFiles(entry, mediaFiles, options) {
    const files = entry ? [entry, ...mediaFiles] : mediaFiles;

    if (options.useWorkflow) {
      return this.editorialWorkflowGit(files, entry, options);
    } else {
      const items = await this.getCommitItems(files, this.branch);
      return this.uploadAndCommit(items, options.commitMessage);
    }
  }

  deleteFile(path, comment, branch = this.branch) {
    return this.getRef(branch).then(ref => {
      const commit = new AzureCommit(comment);
      commit.changes.delete(path);
      const push = new AzurePush(ref);
      push.commits.push(commit);
      return this.requestJSON({
        url: "".concat(this.endpointUrl, "/pushes"),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(push)
      });
    });
  }

  contentKeyFromBranch(branch) {
    return branch.substring("".concat(_netlifyCmsLibUtil.CMS_BRANCH_PREFIX, "/").length);
  }

  branchFromContentKey(contentKey) {
    return "".concat(_netlifyCmsLibUtil.CMS_BRANCH_PREFIX, "/").concat(contentKey);
  }

  async getPullRequests(sourceBranch) {
    const pullRequests = await this.requestJSON({
      url: "".concat(this.endpointUrl, "/pullrequests"),
      params: _objectSpread({
        'searchCriteria.status': 'active',
        // eslint-disable-next-line @typescript-eslint/camelcase
        'searchCriteria.targetRefName': this.branchToRef(this.branch),
        'searchCriteria.includeLinks': false
      }, sourceBranch ? {
        'searchCriteria.sourceRefName': this.branchToRef(sourceBranch)
      } : {})
    });
    return pullRequests.value.filter(mr => mr.sourceRefName.startsWith(this.branchToRef(_netlifyCmsLibUtil.CMS_BRANCH_PREFIX)));
  }
  /**
   * Gets a list of all unpublished branches, which is a list of the pending
   * merge requests projected to just their source branch names.
   */


  async listUnpublishedBranches() {
    const pullRequests = await this.getPullRequests();
    const branches = pullRequests.map(mr => this.refToBranch(mr.sourceRefName));
    return branches;
  }

  async isFileExists(path, branch) {
    return await this.requestText({
      url: "".concat(this.endpointUrl, "/items/"),
      params: {
        version: branch,
        path
      },
      cache: 'no-store'
    }).then(() => {
      return true;
    }).catch(error => {
      if (error instanceof _netlifyCmsLibUtil.APIError && error.status === 404) {
        return false;
      }

      throw error;
    });
  }
  /**
   * Creates a new pull request with a label of "draft", based on the target branch.
   * See documentation at: https://docs.microsoft.com/en-us/rest/api/azure/devops/git/pull%20requests/create?view=azure-devops-rest-5.1
   * @param branch The branch to create the pull request from.
   * @param commitMessage A message to use as the title for the pull request.
   * @param status The status of the pull request.
   */


  async createPullRequest(branch, commitMessage, status) {
    const pr = {
      sourceRefName: this.branchToRef(branch),
      targetRefName: this.branchToRef(this.branch),
      title: commitMessage,
      description: _netlifyCmsLibUtil.DEFAULT_PR_BODY,
      labels: [{
        name: (0, _netlifyCmsLibUtil.statusToLabel)(status)
      }]
    };
    await this.requestJSON({
      method: 'POST',
      url: "".concat(this.endpointUrl, "/pullrequests"),
      params: {
        supportsIterations: false
      },
      body: JSON.stringify(pr)
    });
  }

  async getBranchPullRequest(branch) {
    const pullRequests = await this.getPullRequests(branch);

    if (pullRequests.length <= 0) {
      throw new _netlifyCmsLibUtil.EditorialWorkflowError('content is not under editorial workflow', true);
    }

    return pullRequests[0];
  }

  async getDifferences(to) {
    const result = await this.requestJSON({
      url: "".concat(this.endpointUrl, "/diffs/commits"),
      params: {
        baseVersion: this.branch,
        targetVersion: this.refToBranch(to)
      }
    });
    return result.changes;
  }

  async editorialWorkflowGit(files, entry, options) {
    const contentKey = (0, _netlifyCmsLibUtil.generateContentKey)(options.collectionName, entry.slug);
    const branch = this.branchFromContentKey(contentKey);
    const unpublished = options.unpublished || false;

    if (!unpublished) {
      const items = await this.getCommitItems(files, this.branch);
      await this.uploadAndCommit(items, options.commitMessage, branch, true);
      await this.createPullRequest(branch, options.commitMessage, options.status || this.initialWorkflowStatus);
    } else {
      const items = await this.getCommitItems(files, branch);
      await this.uploadAndCommit(items, options.commitMessage, branch, true);
    }
  }
  /**
   * Gets a pull request and updates labels to allow it to move between different
   * states in the editorial workflow.
   * @param collection The Jekyll collection the item is in.
   * @param slug The slug for the content item.
   * @param newStatus The new status for the item.
   */


  async updateUnpublishedEntryStatus(collection, slug, newStatus) {
    const contentKey = (0, _netlifyCmsLibUtil.generateContentKey)(collection, slug);
    const branch = this.branchFromContentKey(contentKey);
    const mergeRequest = await this.getBranchPullRequest(branch);
    const labels = [...mergeRequest.labels.filter(label => !(0, _netlifyCmsLibUtil.isCMSLabel)(label.name)).map(label => label.name), (0, _netlifyCmsLibUtil.statusToLabel)(newStatus)];
    await this.updatePullRequestLabels(mergeRequest, labels);
  }

  async deleteUnpublishedEntry(collectionName, slug) {
    const contentKey = (0, _netlifyCmsLibUtil.generateContentKey)(collectionName, slug);
    const branch = this.branchFromContentKey(contentKey);
    const mergeRequest = await this.getBranchPullRequest(branch);
    await this.abandonPullRequest(mergeRequest);
  }

  async publishUnpublishedEntry(collectionName, slug) {
    const contentKey = (0, _netlifyCmsLibUtil.generateContentKey)(collectionName, slug);
    const branch = this.branchFromContentKey(contentKey);
    const mergeRequest = await this.getBranchPullRequest(branch);
    await this.completePullRequest(mergeRequest);
  }

  async updatePullRequestLabels(pullRequest, labels) {
    for (const l of pullRequest.labels) {
      if ((0, _netlifyCmsLibUtil.isCMSLabel)(l.name)) {
        await this.requestText({
          method: 'DELETE',
          url: "".concat(this.endpointUrl, "/pullrequests/").concat(encodeURIComponent(pullRequest.pullRequestId), "/labels/").concat(encodeURIComponent(l.id)),
          params: {
            'api-version': '5.1-preview.1'
          }
        });
      }
    }

    for (const l of labels) {
      await this.requestText({
        method: 'POST',
        url: "".concat(this.endpointUrl, "/pullrequests/").concat(encodeURIComponent(pullRequest.pullRequestId), "/labels"),
        params: {
          'api-version': '5.1-preview'
        },
        body: JSON.stringify({
          name: l
        })
      });
    }
  }
  /**
   * Completes the pull request, setting an appropriate merge commit message
   * and ensuring that the source branch is also deleted.
   * @param mergeRequest The merge request provided by a previous GET operation.
   */


  async completePullRequest(mergeRequest) {
    // This is the minimum payload required to complete the pull request.
    const pullRequestCompletion = {
      status: AzurePullRequestStatus.COMPLETED,
      lastMergeSourceCommit: mergeRequest.lastMergeSourceCommit,
      completionOptions: {
        deleteSourceBranch: true,
        mergeCommitMessage: "Completed merge of ".concat(mergeRequest.title),
        mergeStrategy: this.squashMerges ? 'squash' : 'noFastForward'
      }
    };
    let response = await this.requestJSON({
      method: 'PATCH',
      url: "".concat(this.endpointUrl, "/pullrequests/").concat(encodeURIComponent(mergeRequest.pullRequestId)),
      body: JSON.stringify(pullRequestCompletion)
    }); // We need to wait for Azure to complete the pull request to actually complete
    // Sometimes this is instant, but frequently it is 1-3 seconds

    while (response.mergeStatus === 'queued') {
      await delay(500);
      response = await this.requestJSON({
        url: "".concat(this.endpointUrl, "/pullrequests/").concat(encodeURIComponent(mergeRequest.pullRequestId))
      });
    }
  }
  /**
   * Abandons the pull request status and ensuring that the source branch is also deleted.
   * @param pullRequest The pull request provided by a previous GET operation.
   */


  async abandonPullRequest(pullRequest) {
    const pullRequestAbandon = {
      status: AzurePullRequestStatus.ABANDONED
    };
    await this.requestJSON({
      method: 'PATCH',
      url: "".concat(this.endpointUrl, "/pullrequests/").concat(encodeURIComponent(pullRequest.pullRequestId)),
      body: JSON.stringify(pullRequestAbandon)
    }); // Also delete the source branch.

    await this.deleteRef(new AzureRef(pullRequest.sourceRefName, pullRequest.lastMergeSourceCommit.commitId));
  }

}

exports.default = API;